/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {ObjectDefinition} from "../models/object-definition";
import {ObjectService} from "../services/object.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class DevicesResolver implements Resolve<ObjectDefinition[]> {

  constructor(
    private mObjectService: ObjectService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<ObjectDefinition[]> {
    try {
      return await this.mObjectService.getAllDeviceObjects();
    } catch (error) {
      console.error("Problem resolving Device Types... Error: " + error, error);
    }
  }

}
